import { useEffect, useRef, type ReactNode } from "react";
import { XCloseIcon } from "@/shared/ui/icons/XCloseIcon";

export function FullScreenDialog({
  title,
  onClose,
  children,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (el === null || el.open) return;
    el.showModal();
  }, []);

  return (
    <dialog
      ref={ref}
      aria-labelledby="fullscreen-dialog-title"
      onClose={onClose}
      className="m-0 h-full max-h-none w-full max-w-none border-0 bg-white-50 p-0 text-black-600 backdrop:bg-black-800/40 md:m-auto md:h-[min(80dvh,760px)] md:w-[720px] md:rounded-3xl"
    >
      <div className="flex h-full flex-col">
        <div className="flex shrink-0 items-center justify-between gap-2 border-b border-white-300 px-4 py-3">
          <h2
            id="fullscreen-dialog-title"
            className="m-0 text-body-lg font-semibold"
          >
            {title}
          </h2>
          <button
            type="button"
            className="ui-pressable flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-0 text-black-300"
            onClick={onClose}
            aria-label="닫기"
          >
            <XCloseIcon />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-4 py-5">
          {children}
        </div>
      </div>
    </dialog>
  );
}
